.root {
    grid-column: 1 / -1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--spacer-40);

    :global(.imageDataWrapper) {
        height: var(--spacer-80);
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
            max-height: var(--spacer-80);
            width: auto;
            display: block;
        }
    }
}

.logo {
    height: var(--spacer-80);
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        max-height: var(--spacer-80);
        width: auto;
        display: block;
        object-fit: contain;
    }
}
